// 付款方式
export const paymentType = {
  CASH_CREDIT_TRANSFER: "現金、信用卡、匯款",
  LOAN: "貸款",
  ONLINE_CARD: "線上刷卡",
  CHANNEL_PAYMENT: "通路付款",
  WALLET: "Gogoro Wallet",
  QR_PAY: "永豐 QR 線上刷卡",
}

export const payTypeOption = [
  paymentType.CASH_CREDIT_TRANSFER,
  paymentType.LOAN,
  paymentType.ONLINE_CARD,
  paymentType.CHANNEL_PAYMENT,
  paymentType.WALLET,
]

export const companyIdentityType = {
  DIRECT: "Direct",
  FRANCHISE: "Franchise",
  NONE: "None",
}

// A:gogoro門市 P:智慧電動機車推廣計劃 O:遠傳折價券 Q:台哥大折價券 R:中華電信折價券 C:專案銷售
export const GOGORO_STORE_CHANNEL = "A"
export const AR_STORE_CHANNEL = "Y"
export const CARREFOUR_CHANNEL = "H"
export const RTMART_CHANNEL = "I"
export const PCHOME_CHANNEL = "S"
export const MOMO_CHANNEL = "B04"
export const YAHOO_CHANNEL = "U"
export const COCORO_CHANNEL = "V"
export const FACILITATING_CHANNEL = "P"
export const REPLACEMENT_CHANNEL = "Z"
export const COSTCO_CHANNEL = "B01"
export const PXMART_CHANNEL = "B02"
export const GQS_STORE_CHANNEL = "B03"
export const NORMAL_CHANNELS = [
  "A",
  "P",
  "O",
  "Q",
  "R",
  "C",
  "X",
  PXMART_CHANNEL,
  AR_STORE_CHANNEL,
  REPLACEMENT_CHANNEL,
  GQS_STORE_CHANNEL,
]
export const TELECOM_CHANNELS = ["O", "Q", "R"]
export const PARTNER_CHANNELS = [
  CARREFOUR_CHANNEL,
  RTMART_CHANNEL,
  PCHOME_CHANNEL,
  YAHOO_CHANNEL,
  COCORO_CHANNEL,
  COSTCO_CHANNEL,
  MOMO_CHANNEL,
]
export const ONLINE_CHANNELS = [PCHOME_CHANNEL, YAHOO_CHANNEL, COCORO_CHANNEL, MOMO_CHANNEL]
